// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609250634/js/" + chunkId + "." + {"44":"90b95d23","225":"4a8c5a66","481":"80b0b787","486":"be373e28","770":"47f8ba66"}[chunkId] + ".0.6734597914879571.chunk.js";
};